import React from "react";
import {useState,useEffect,useRef} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from 'primereact/inputtextarea';
import {Tag} from "primereact/tag";
import Message from "../Helpers/Message.js";
import {fetch_url_post,fetch_download,focus_next} from "../../Sources/js/app.js";

let oper="";

let currentDate=new Date();
let currentYear=currentDate.getFullYear();
let yearsList=[];

for(let i=-2;i<2;i++) {
	let cYear={
		label: currentYear+i,
		value: currentYear+i
	}
	yearsList.push(cYear);
} 

let defaultInputValues={
	id: null,
	center_id: 0,
	year: currentYear,
	observations: "",
	filter_centers: "",
	filter_years: currentYear,
	active: 1,
};

let defaultInputValuesProducts={
	id: null,
	centers_requests_id: 0,
	product_id: 0,
	product_mu_id: "",
	quantity: "",
	filter_products: "",
	product_type_id: 0,
	filter_product_type: "",
	observations: "",
	multiplier: 1,
};

let defaultInputValuesTemplates={
	id: null,
	name: "",
	observations: "",
	filter_templates: "",
};

let defaultDataValues={
	centersRequestsList: [],
	productsList: [],
	MUsList:[],
	centersList: [],
	requestProductsList: [],
	productsTypesList: [],
	templatesList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openAddEditProduct: false,
	titleAddEditProduct: "",
	openListProducts: false,
	titleListProducts: "",
	openAddEditTemplate: false,
	titleAddEditTemplate: "",
	openListTemplates: false,
	titleListTemplates: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let activeList=[
	{label: "DA",value: 1},
	{label: "NU",value: 0},
];

let multiplierList=[
	{label: "1",value: 1},
	{label: "2",value: 2},
	{label: "3",value: 3},
	{label: "4",value: 4},
	{label: "5",value: 5},
	{label: "6",value: 6},
	{label: "7",value: 7},
	{label: "8",value: 8},
	{label: "9",value: 9},
	{label: "10",value: 10},
	{label: "11",value: 11},
	{label: "12",value: 12},
];

let currentRequest={};

const CentersRequestsYearly = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.providerId?props.providerId:null);
	let ct=1;

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [centersRequestsList, setCentersRequestsList] = useState([]);
	const [inputValuesProducts, setInputValuesProducts] = useState(defaultInputValuesProducts);
	const [requestProductsList, setRequestProductsList] = useState([]);
	const [productsList, setProductsList] = useState([]);
	const [inputValuesTemplates, setInputValuesTemplates] = useState(defaultInputValuesTemplates);
	const [templatesList, setTemplatesList] = useState([]);
	const [tableQuantities, setTableQuantities] = useState([]);
	const [tableMultipliers, setTableMultipliers] = useState([]);
	const xlsUploadRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="center_id") {
			let found=false;
			if(dataValues.centersRequestsList.length>0) {
				dataValues.centersRequestsList.forEach(element => {
					if((value===element.center_id)&&(inputValues.year===element.year)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un necesar pentru centrul si anul selectat!":""),
			}
			setInputError(tmp);
		}
		if(name==="year") {
			let found=false;
			if(dataValues.centersRequestsList.length>0) {
				dataValues.centersRequestsList.forEach(element => {
					if((value===element.year)&&(inputValues.center_id===element.center_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un necesar pentru centrul si anul selectat!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_centers") {
			setCentersRequestsList(dataValues.centersRequestsList
																.filter((request)=>((request.center_name.toLowerCase().indexOf(value.toLowerCase())>-1)||(value==="")))
																.filter((request)=>((request.year===inputValues.filter_years)||(inputValues.filter_years==="")))
																.filter((request)=>((request.month===inputValues.filter_months)||(inputValues.filter_months==="")))
																.filter((request)=>((request.type_id===inputValues.filter_types)||(inputValues.filter_types==="")||(!inputValues.filter_types)))
			);
		}
		if(name==="filter_years") {
			setCentersRequestsList(dataValues.centersRequestsList
																.filter((request)=>((request.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1)||(inputValues.filter_centers==="")))
																.filter((request)=>((request.year===value)||(value==="")))
																.filter((request)=>((request.month===inputValues.filter_months)||(inputValues.filter_months==="")))
																.filter((request)=>((request.type_id===inputValues.filter_types)||(inputValues.filter_types==="")||(!inputValues.filter_types)))
			);
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChangeProducts = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="product_id") {
			let tmp=dataValues.productsList.filter((product)=>(product.id===value));
			setInputValuesProducts({...inputValuesProducts,product_mu_id:tmp[0].product_mu_id,
															product_id:value
			});
			state_update=1;
			let found=false;
			if(dataValues.requestProductsList.length>0) {
				dataValues.requestProductsList.forEach(element => {
					if((value===element.product_id)&&(tmp[0].product_mu_id===element.product_mu_id)) {
						found=true;
					}
				});
			}
			tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="product_mu_id") {
			let found=false;
			if(dataValues.requestProductsList.length>0) {
				dataValues.requestProductsList.forEach(element => {
					if((value===element.product_mu_id)&&(inputValuesProducts.product_id===element.product_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_products") {
			setRequestProductsList(dataValues.requestProductsList
																.filter((product)=>((product.product_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value===""))
																.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")||(!inputValuesProducts.filter_product_type)))
			);
		}
		if(name==="filter_product_type") {
			setRequestProductsList(dataValues.requestProductsList
																.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																.filter((product)=>((product.product_type_id===value)||(value==="")||(!value)))
			);
		}
		if(name==="product_type_id") {
			setProductsList(dataValues.productsList
												.filter((product)=>((product.product_type_id===value)||(value==="")||(!value)))
			);
		}
		if(!state_update) {
			setInputValuesProducts({...inputValuesProducts,[name]:value});
		}
	}

	const handleChangeTemplates = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.templatesList.length>0) {
				dataValues.templatesList.forEach(element => {
					if(value===element.name) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un sablon cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_templates") {
			setTemplatesList(dataValues.templatesList.filter((template)=>((template.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValuesTemplates({...inputValuesTemplates,[name]:value});
	}

	const handleChangeTable = (evt,id) => {
		const {name, value} = evt.target;
		if(name==="quantity_table") {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
			let tmp={...tableQuantities};
			tmp[id]=value;
			setTableQuantities(tmp);
		}
	}

	const handleFocusTable = (evt) => {
		if(evt.keyCode===13) {
			focus_next(evt);
		}
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare necesar nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_centers=inputValues.filter_centers;
			elementData.filter_years=inputValues.filter_years;
			setInputValues(elementData);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare necesar "+elementData.center_name+" pentru anul "+elementData.year});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteCenterRequest";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValues.center_id) {
				setMessageText("Eroare: Alegeti un centru din lista!");				
				document.getElementById("center_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.year) {
				setMessageText("Eroare: Alegeti anul!");				
				document.getElementById("year").classList.add("required_input_error");
				return false;
			}
			let url="saveCenterRequest";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_products") {
			let url="getCenterRequestProducts";
			url+="?session_id="+props.session.sessId;
			oper="list_products";
			let data={
				centers_requests_id: elementData.id,
			};
			currentRequest=elementData;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_product") {
			setProductsList(dataValues.productsList);
			setInputValuesProducts(defaultInputValuesProducts);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Adaugare produs nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit_product") {
			let url="saveQuantitiesCenterYearlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="edit_product";
			let tmp=[];
			Object.entries(tableQuantities).forEach(([id,quantity]) => {
				let c_quantity={};
				c_quantity.id=id;
				c_quantity.quantity=quantity;
				tmp.push(c_quantity);
			});
			let data={
				no_message: 1,
				quantities: tmp,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
			elementData.filter_products=inputValuesProducts.filter_products;
			elementData.filter_product_type=inputValuesProducts.filter_product_type;
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===elementData.product_type_id)||(elementData.product_type_id==="")||(!elementData.product_type_id))));			
			setInputValuesProducts(elementData);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Editare produs "});
			setInputError(defaultInputError);
		}
		if(what==="delete_product") {
			let url="deleteCenterRequestProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete_product";
			let data={
				id: elementData.id,
				centers_requests_id: currentRequest.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_product") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValuesProducts.product_id) {
				setMessageText("Eroare: Alegeti un produs din lista!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.product_mu_id) {
				setMessageText("Eroare: Alegeti o unitate de masura!");				
				document.getElementById("product_mu_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.quantity) {
				setMessageText("Eroare: Completati cantitatea!");				
				document.getElementById("quantity").classList.add("required_input_error");
				return false;
			}
			let url="saveCenterRequestProduct";
			url+="?session_id="+props.session.sessId;
			oper="save_product";
			let data={...inputValuesProducts};
			data.centers_requests_id=currentRequest.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_as_template") {
			setInputValuesTemplates(defaultInputValuesTemplates);
			setDialogValues({...dialogValues,openAddEditTemplate: true,titleAddEditTemplate: "Salveaza ca sablon"});
			setInputError(defaultInputError);
		}
		if(what==="save_template") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValuesTemplates.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("template_name").classList.add("required_input_error");
				return false;
			}
			let url="saveTemplate";
			url+="?session_id="+props.session.sessId;
			oper="save_template";
			let data={...inputValuesTemplates};
			data.centers_requests_id=currentRequest.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="apply_template") {
			setDialogValues({...dialogValues,openListTemplates: true,titleListTemplates: "Aplica sablon"});
		}
		if(what==="save_apply_template") {
			let url="applyTemplateToCenterYearlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="save_apply_template";
			let data={
				template_id: elementData.id,
				centers_requests_id: currentRequest.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_quantities") {
			let url="saveQuantitiesCenterYearlyRequest";
			url+="?session_id="+props.session.sessId;
			oper="save_quantities";
			let tmp=[];
			Object.entries(tableQuantities).forEach(([id,quantity]) => {
				let c_quantity={};
				c_quantity.id=id;
				c_quantity.quantity=quantity;
				tmp.push(c_quantity);
			});
			let data={
				quantities: tmp,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="download_xls") {
			let url="getXLSCenterRequestProducts";
			url+="?session_id="+props.session.sessId;
			let data={
				centers_requests_id: currentRequest.id,
			};
			let filename="necesar_anual_"+(currentRequest.center_name?currentRequest.center_name.replace(/[^a-zA-Z0-9]/g,"_"):"produse");
			fetch_download(url,data,filename,success_handler);
			setBlockScreen(true);
			setMessageText("Se genereaza fisierul XLS...");
		}
		if(what==="import_xls_click") {
			if(window.confirm("Cantitatile existente vor fi suprascrise. Continuati?")) {
				if(xlsUploadRef.current) xlsUploadRef.current.click();
			}
		}
	}

	const handleXlsImport = (evt) => {
		const file = evt.target.files[0];
		if(!file) return;
		evt.target.value = "";
		const formData = new FormData();
		formData.append("xls_file", file);
		formData.append("centers_requests_id", currentRequest.id);
		formData.append("session_id", props.session.sessId);
		let url = "importXLSCenterRequestProducts?session_id=" + props.session.sessId;
		const api_base = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "") + "/api3/";
		setBlockScreen(true);
		setMessageText("Se importa fisierul XLSX...");
		fetch(api_base + url, {method: "POST", body: formData})
			.then(r => r.json())
			.then(result => {
				setBlockScreen(false);
				if(result.ok === 0) {
					setMessageText("Eroare: " + result.error);
					return;
				}
				const updatedList = result.requestProductsList || [];
				setDataValues({...dataValues, requestProductsList: updatedList});
				setRequestProductsList(
					updatedList
						.filter(p => (p.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase()) > -1) || inputValuesProducts.filter_products === "")
						.filter(p => (p.product_type_id === inputValuesProducts.filter_product_type) || inputValuesProducts.filter_product_type === "" || !inputValuesProducts.filter_product_type)
				);
				if(updatedList.length > 0) {
					let tmp={}, tmp_1={};
					updatedList.forEach(function(product) {
						tmp[product.id]=product.quantity;
						tmp_1[product.id]=product.multiplier;
					});
					setTableQuantities(tmp);
					setTableMultipliers(tmp_1);
				}
				setMessageText(result.message || "Import finalizat!");
			})
			.catch(err => {
				setBlockScreen(false);
				setMessageText("Eroare la import: " + err.message);
			});
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			if(oper==="get") {
				setDataValues({...dataValues,centersRequestsList:(result.centersRequestsList?result.centersRequestsList:[]),
											productsList:(result.productsList?result.productsList:[]),
											MUsList:(result.MUsList?result.MUsList:[]),
											centersList:(result.centersList?result.centersList:[]),
											productsTypesList:(result.productsTypesList?result.productsTypesList:[])
				});
			}else{
				setDataValues({...dataValues,centersRequestsList:(result.centersRequestsList?result.centersRequestsList:[])});				
			}
			setCentersRequestsList(result.centersRequestsList?result.centersRequestsList
																					.filter((request)=>((request.center_name.toLowerCase().indexOf(inputValues.filter_centers.toLowerCase())>-1))||(inputValues.filter_centers===""))
																					.filter((request)=>((request.year===inputValues.filter_years))||(inputValues.filter_years===""))
			:[]);
			setProductsList(result.productsList?result.productsList:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if((oper==="list_products")||(oper==="save_product")||(oper==="delete_product")) {
			if(oper==="list_products") {
				setDataValues({...dataValues,requestProductsList:(result.requestProductsList?result.requestProductsList:[]),
											templatesList:(result.templatesList?result.templatesList:[])
				});							
				setTemplatesList(result.templatesList?result.templatesList:[]);
			}else{
				setDataValues({...dataValues,requestProductsList:(result.requestProductsList?result.requestProductsList:[])});											
			}
			setInputValuesProducts(defaultInputValuesProducts);
			setRequestProductsList(result.requestProductsList?result.requestProductsList
																					.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1)||(inputValuesProducts.filter_products==="")))
																					.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")))
			:[]);
			setDialogValues({...dialogValues,openListProducts: true,titleListProducts: "Lista de produse pentru necesarul ["+currentRequest.center_name+" - "+currentRequest.year+"]",
											openAddEditProduct: false,titleAddEditProduct: ""
			});
			if(result.requestProductsList) {
				let tmp={};
				let tmp_1={};
				result.requestProductsList.forEach(function(product) {
					tmp[product.id]=product.quantity;
					tmp_1[product.id]=product.multiplier;
				});
				setTableQuantities(tmp);
				setTableMultipliers(tmp_1);
			}
			oper="";
		}
		if(oper==="save_template") {
			setDataValues({...dataValues,templatesList:(result.templatesList?result.templatesList:[])});	
//			setDialogValues({...dialogValues,openAddEditTemplate: false,titleAddEditTemplate: ""});
			oper="";
		}
		if(oper==="save_apply_template") {
			setDataValues({...dataValues,requestProductsList:(result.requestProductsList?result.requestProductsList:[])});										
			setRequestProductsList(result.requestProductsList?result.requestProductsList:[]);													
			setDialogValues({...dialogValues,openListTemplates: false,titleListTemplates: ""});
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getCentersRequests";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={8} lg={8} className="field padding-med">
						<label htmlFor="center_id">Centru*</label>
						<Dropdown name="center_id" id="center_id" style={{"width":"100%"}} filter options={dataValues.centersList} optionLabel="name" optionValue="id" value={inputValues.center_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={2} lg={2} className="field padding-med">
						<label htmlFor="year">Anul*</label>
						<Dropdown name="year" id="year" style={{"width":"100%"}} options={yearsList} value={inputValues.year} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={6} sm={6} md={2} lg={2} className="field padding-med">
						<label htmlFor="active">Activ</label>
						<Dropdown name="active" id="active" style={{"width":"100%"}} options={activeList} value={inputValues.active} onChange={(evt) => handleChange(evt)}/>
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listProductsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListProducts} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListProducts:false})} className="responsive-dialog-big">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValuesProducts.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChangeProducts(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3} className="field padding-med">
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"100%"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValuesProducts.filter_product_type} onChange={(evt) => handleChangeProducts(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={5} lg={5} xl={5} className="field padding-med text-right">
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"9px"}} onClick={(evt) => {handleButton(evt,"save_quantities")}}/>
							<Button label="Salveaza ca sablon" icon="pi pi-file-export" className="p-button-sm p-button-primary p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => {handleButton(evt,"save_as_template")}} disabled={(requestProductsList.length>0?false:true)}/>
							<Button label="Aplica sablon" icon="pi pi-copy" className="p-button-sm p-button-primary p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => {handleButton(evt,"apply_template")}} disabled={(requestProductsList.length>0?true:false)}/>
							<Button label="Adauga produs" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => {handleButton(evt,"add_product")}}/>
							<Button label="Descarca XLS" icon="pi pi-file-excel" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => {handleButton(evt,"download_xls")}}/>
							<Button label="Actualizeaza XLS" icon="pi pi-upload" className="p-button-sm p-button-warning p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"import_xls_click")}}/>
							<input type="file" accept=".xlsx" ref={xlsUploadRef} style={{"display":"none"}} onChange={(evt) => handleXlsImport(evt)}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={requestProductsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							rowGroupMode="rowspan"
							groupRowsBy="product_type"
							sortMode="single"
							sortField="product_type"
							sortOrder={1}
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="product_type" header="Tip produs" style={{"width":"18%","backgroundColor":"#FFFFFF"}} body={tableColTemplateProducts}></Column>
							<Column field="product_name" header="Produs" style={{"width":"32%"}}></Column>
							<Column field="product_mu" header="U.M." style={{"width":"130px"}}></Column>
							<Column field="quantity" header="Cantitate" style={{"width":"100px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="multiplier" header="Multi." style={{"width":"60px","textAlign":"center","display":"none"}}></Column>							
							<Column field="observations" header="Observatii" style={{"overflow":"hidden","maxWidth":"190px","textOverflow":"ellipsis"}}></Column>
							<Column field="buttons" header="" style={{"width":"195px"}} body={tableColTemplateProducts}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const addEditProductDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditProduct} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_type_id">Categorie*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"100%"}} filter options={dataValues.productsTypesList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_type_id} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_id">Produs* ({productsList.length} produse gasite)</label>
						<Dropdown name="product_id" id="product_id" style={{"width":"100%"}} filter options={productsList} optionLabel="name" optionValue="id" value={inputValuesProducts.product_id} onChange={(evt) => handleChangeProducts(evt)} disabled={(inputValuesProducts.product_type_id?false:false)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"100%"}} options={dataValues.MUsList} filter value={inputValuesProducts.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="quantity">Cantitate*</label>
						<InputText name="quantity" id="quantity" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="multiplier">Multiplicator*</label>
						<Dropdown name="multiplier" id="multiplier" style={{"width":"100%"}} options={multiplierList} value={inputValuesProducts.multiplier} disabled={true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesProducts.observations} onChange={(evt) => handleChangeProducts(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_product")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const addEditTemplateDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditTemplate} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditTemplate:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="template_name">Nume sablon*</label>
						<InputText name="name" id="template_name" style={{"width":"100%"}} value={inputValuesTemplates.name} onChange={(evt) => handleChangeTemplates(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesTemplates.observations} onChange={(evt) => handleChangeTemplates(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_template")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditTemplate:false})}/>
					</Grid>
				</Grid>
				<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
					<DataTable
						value={dataValues.templatesList}
						scrollable
						scrollHeight="45vh"
						style={{"minHeight":"48vh","marginTop":"6px"}}
						scrollDirection="both"
						stripedRows
						resizableColumns
						emptyMessage="Nu exista inregistrari"
					>
						<Column field="name" header="Nume sablon" style={{"width":"30%","backgroundColor":"#FFFFFF"}}></Column>
						<Column field="observations" header="Observatii sablon" style={{"width":"50%"}}></Column>
						<Column field="reg_date_parsed" header="Data introducerii" style={{"width":"183px"}}></Column>
					</DataTable>
				</Box>
				<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

				</Box>
			</Dialog>
		);
	}

	const listTemplatesDialog = () => {
		return(
			<Dialog header={dialogValues.titleListTemplates} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListTemplates:false})} className="responsive-dialog-med">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="field padding-med">
							<InputText name="filter_templates" id="filter_templates" style={{"width":"100%"}} value={inputValuesTemplates.filter_templates} placeholder="Cauta sablon..." onChange={(evt) => handleChangeTemplates(evt)}/>							
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={templatesList}
							scrollable
							scrollHeight="45vh"
							style={{"minHeight":"45vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="name" header="Nume sablon" style={{"width":"35%"}} sortable></Column>
							<Column field="observations" header="Observatii" style={{"width":"60%"}}></Column>
							<Column field="buttons" header="" style={{"width":"100px"}} body={tableColTemplateTemplate}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza necesar" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Produse" icon="pi pi-list" tooltip="Lista de produse" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"list_products",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge necesar" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
		if(column.field==="active") {
			if(row_data.active===1) {
				return(
					<span>
						<Tag severity="success" style={{"marginLeft":"12px"}} value="ACTIV"></Tag>
					</span>
				)
			}else{
				return(
					<span>
						<Tag severity="danger" style={{"marginLeft":"12px"}} value="INACTIV"></Tag>
					</span>
				)
			}
		}
	}

	const tableColTemplateProducts = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza produs" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_product",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge produs" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete_product",row_data)}/>
				</span>
			);
		}
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}		
		if(column.field==="quantity") {
			return <InputText name="quantity_table" id={row_data.id} className="p-inputtext_table" value={tableQuantities[row_data.id]} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id)} onKeyDown={(evt) => handleFocusTable(evt)} />;			
		}
	}

	const tableColTemplateTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Aplica" icon="pi pi-check-circle" tooltip="Editeaza necesar" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"save_apply_template",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if((what==="delete")||(what==="delete_product")) {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={6} md={6} lg={5} xl={5} className="field padding-med">
							<InputText name="filter_centers" id="filter_centers" style={{"width":"69%","float":"left"}} value={inputValues.filter_centers} placeholder="Cauta centru..." onChange={(evt) => handleChange(evt)}/>							
							<Dropdown name="filter_years" id="filter_years" style={{"width":"29%","marginLeft":"6px"}} options={yearsList} value={inputValues.filter_years} onChange={(evt) => handleChange(evt)}/>	
						</Grid>						
						<Grid item xs={12} sm={3} md={3} lg={4} xl={4} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{centersRequestsList.length} {(((centersRequestsList.length>1)||(centersRequestsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={3} md={3} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga necesar nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={centersRequestsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="center_name" header="Nume centru" style={{"flexGrow":"1","flexBasis":"150px"}} sortable></Column>
								<Column field="year" header="Anul" style={{"flexGrow":"0","flexBasis":"75px"}} sortable></Column>
								<Column field="observations" header="Observatii" style={{"flexGrow":"0","flexBasis":"430px"}}></Column>
								<Column field="active" header="Stare" style={{"flexGrow":"0","flexBasis":"90px"}} body={tableColTemplate} sortable></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"285px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openAddEditProduct && addEditProductDialog()}
				{dialogValues.openListProducts && listProductsDialog()}
				{dialogValues.openAddEditTemplate && addEditTemplateDialog()}
				{dialogValues.openListTemplates && listTemplatesDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default CentersRequestsYearly;


